import { Badge, Text } from "@mantine/core";
import { IconChecklist } from "@tabler/icons-react";
import React from "react";
import { getSkypointDocCompletion } from "../../../services/skypointAlerts";
import SkypointAlertsTablePage from "./SkypointAlertsTablePage";

const pctColor = (p) => (p >= 90 ? "green" : p >= 60 ? "yellow" : p >= 30 ? "orange" : "red");

const columns = [
  {
    key: "provider",
    header: "Provider",
    render: (item) => (
      <Text weight={500} size="sm">
        {item.providerName}
      </Text>
    ),
  },
  {
    key: "total",
    header: "Templates",
    width: 110,
    render: (item) => <Text size="sm">{item.totalTemplates}</Text>,
  },
  {
    key: "fulfilled",
    header: "Fulfilled",
    width: 110,
    render: (item) => <Text size="sm">{item.fulfilledTemplates}</Text>,
  },
  {
    key: "missing",
    header: "Missing",
    width: 110,
    render: (item) => (
      <Badge
        color={item.missingTemplates === 0 ? "green" : "red"}
        variant="light"
        size="sm"
      >
        {item.missingTemplates}
      </Badge>
    ),
  },
  {
    key: "pct",
    header: "Completion",
    width: 140,
    render: (item) => (
      <Badge color={pctColor(item.percentage)} variant="light" size="sm">
        {item.percentage}%
      </Badge>
    ),
  },
];

const DocCompletion = ({ isSidebarOpen }) => (
  <SkypointAlertsTablePage
    isSidebarOpen={isSidebarOpen}
    title="Documentation Completion"
    description="Required document templates fulfilled vs total, per provider"
    Icon={IconChecklist}
    iconColor="#12B76A"
    iconBg="#ECFDF3"
    columns={columns}
    stateSelector={(state) => state?.skypointAlerts?.docCompletion}
    fetcher={getSkypointDocCompletion}
    emptyMessage="No document templates configured across linked providers."
    itemUnit="provider"
  />
);

export default DocCompletion;
